import VFocus from "@/js/directives/VFocus";

export default [
    VFocus
]